// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyAvailabilityWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyAvailabilityConfirmResponseWebDto } from '../..';

interface ConfirmParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyAvailabilityWebApiHandler_confirm_Path =
  '/api/web/v1/users/properties/availability/confirm';

/**
 * Confirm listing availability
 */
export const RentalManagerUserPropertyAvailabilityWebApiHandler_confirm = (
  getParams: ConfirmParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ConfirmParams, never, UserPropertyAvailabilityConfirmResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyAvailabilityWebApiHandler_confirm_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
